import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import AlertItem from './AlertItem';
import WrongBillToTable from './WrongBillToTable';

const WrongBillToAlert = (props) => {
  const { alert } = props;
  const {
    checkouts,
    appropriate_bill_to,
  } = alert.value;

  return (
    <AlertItem
      alert={alert}
      date={moment(alert.date).format('MMMM Do, YYYY')}
      icon='cubes'
      title={(
        <div>
          {_.size(checkouts)} checkouts were placed with a bill to that was not{' '}
          <strong className='u-colorRed'>
            {appropriate_bill_to}
          </strong>
          {'.'}
        </div>
      )}
      content={(
        <WrongBillToTable
          includeExport={true}
          checkouts={alert.value.checkouts}
        />
      )}
      {...props}
    />
  );
};


WrongBillToAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default WrongBillToAlert;
